import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  class: "icon icon-visibility",
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  fill: "currentColor",
  d: "M12 15.6c1.15 0 2.126-.4 2.926-1.2.8-.8 1.2-1.775 1.2-2.926 0-1.15-.4-2.124-1.2-2.924-.8-.8-1.776-1.2-2.926-1.2-1.15 0-2.126.4-2.926 1.2-.8.8-1.2 1.775-1.2 2.924 0 1.15.4 2.126 1.2 2.926.8.8 1.776 1.2 2.926 1.2Zm0-1.426c-.75 0-1.388-.262-1.913-.787a2.604 2.604 0 0 1-.787-1.913c0-.75.262-1.386.787-1.911A2.602 2.602 0 0 1 12 8.774c.75 0 1.388.263 1.913.789.525.525.787 1.162.787 1.911 0 .75-.262 1.388-.787 1.913a2.604 2.604 0 0 1-1.913.787Zm0 4.326c-2.317 0-4.417-.637-6.3-1.912-1.883-1.276-3.266-2.98-4.15-5.114.884-2.116 2.27-3.807 4.162-5.074S9.7 4.5 12 4.5c2.3 0 4.396.633 6.288 1.9 1.891 1.267 3.278 2.958 4.162 5.074-.884 2.134-2.267 3.838-4.15 5.114-1.883 1.275-3.983 1.912-6.3 1.912Zm0-1.6c1.866 0 3.579-.488 5.137-1.462a9.526 9.526 0 0 0 3.563-3.964c-.817-1.666-2.004-2.978-3.563-3.937C15.58 6.58 13.867 6.1 12 6.1c-1.866 0-3.583.479-5.15 1.437a9.338 9.338 0 0 0-3.575 3.937 9.5 9.5 0 0 0 3.575 3.964A9.567 9.567 0 0 0 12 16.9Z"
}, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3))
}
export default { render: render }